<div *ngIf="isLoading" class="flex-container">
  <div class="bi-spinner"></div>
  <p class="text-flex">{{ 'app.dashboard_tab.loading_dashboard' | translate }}</p>
</div>
<div id="dashboard_tab_container" class="dashboard_tab_container"></div> 